import { useContext } from "react";
import { AppStateContext } from "../state/contexts";

function useAppState() {
  return useContext(AppStateContext);
}

export default useAppState;
